module.exports = __webpack_public_path__ + "static/media/client-carousell.28415189.png";